import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'details-for-client',
  templateUrl: './templates/details-for-client.component.html',
  styleUrls: ['./styles/details-for-client.component.css']
})
export class DetailsForClientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/details-for-client.component.ts